export default "__VITE_ASSET__CuoOBh9d__"